var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"mb-base",attrs:{"title":"Bar Chart","code-toggler":""}},[_c('div',{staticClass:"vx-col w-full sm:w-1/1"},[_c('p',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"mt-5"},[(_vm.show)?_c('chartjs-component-bar-chart',{attrs:{"height":250,"data":_vm.data,"options":_vm.options}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }